import { render, staticRenderFns } from "./OrderAdministrateModal.vue?vue&type=template&id=f8cdac48&scoped=true&"
import script from "./OrderAdministrateModal.vue?vue&type=script&lang=js&"
export * from "./OrderAdministrateModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderAdministrateModal.vue?vue&type=style&index=0&id=f8cdac48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cdac48",
  null
  
)

export default component.exports